export const isNewraiUser = (userData?: GetUserByToken): boolean => {
  return userData?.userCategory?.slug === "newrai";
};
